import React, { memo, useState } from 'react';
import { Row, Col } from 'react-bootstrap';
import { status_code_list, mypage_url } from '../Const';
import Popup from '../molecules/Popup';
interface Props {
  reception_id: number;
  status_code: number;
  has_debtor: boolean;
  handleClickChangeDetails: () => Promise<any>; // 「相談内容を変更する」のアクション
}

// KWANKGM02020_借入相談入力確認
const FooterBorrowingConsultationPreview: React.FC<Props> = ({
  reception_id,
  status_code,
  has_debtor,
  handleClickChangeDetails,
}) => {
  const [modal_change_application_open, setModalChangeApplicationOpen] = useState(false);

  /**
   * KWANKGM00180_メール再送画面 へ遷移
   */
  const handleClickResendMail = () => {
    location.replace(
      `${location.origin}${process.env.MIX_MOCK_URL}/applicant/mail_resend?r_id=${reception_id}`
    );
  };

  // マイページへ戻るボタン押下
  const transitionMypage = () => {
    location.href = mypage_url;
  };

  // 「相談内容を変更する」をクリックした時のアクション
  const handleClickOpenChangeApplication = () => {
    setModalChangeApplicationOpen(true);
  };

  /**
   * 『連帯債務者等の方へ確認依頼メールを再送する』ボタンを表示する
   */
  const jsxElementResendMail = () => {
    //連帯債務者等が0人 or 借入相談登録前 or 借入相談登録後(連帯債務者等の不同意)の場合はボタンを非表示
    if (
      !has_debtor ||
      status_code < status_code_list.borrowing_consultation_checking ||
      status_code === status_code_list.borrowing_consultation_disagreed
    ) {
      return null;
    }

    return (
      <Col xs={12} sm={12} md={12} lg={6} xl={6} className="row-right-button-no-arrow">
        <div className="text-right sp-button-center">
          <a className="btn btn-xl btn-main-color" onClick={handleClickResendMail}>
            連帯債務者等の方へ
            <br className="d-lg-none" />
            確認依頼メールを再送する
          </a>
        </div>
      </Col>
    );
  };

  /**
   * 『相談内容を変更する』ボタンを表示する
   */
  const jsxElementChangeDetails = () => {
    //案件ステータスが借入相談保証人不同意のみボタンを表示
    if (status_code !== status_code_list.borrowing_consultation_disagreed) {
      return null;
    }

    return (
      <Col xs={12} sm={12} md={12} lg={6} xl={6} className="row-right-button-small">
        <div className="text-right sp-button-center">
          <a className="btn btn-xl btn-main-color" onClick={handleClickOpenChangeApplication}>
            相談内容を変更する
          </a>
        </div>
      </Col>
    );
  };

  return (
    <>
      <Row className="my-5 flex-lg-row flex-md-reverse flex-sm-column-reverse flex-column-reverse">
        <Col xl={6} lg={6} md={6} sm={6} xs={12} className="row-left-button-arrow">
          <div className="text-left">
            <a className="btn btn-xl btn-main-color sp-my-page-return" onClick={transitionMypage}>
              マイページへ
              <br className="d-lg-none d-md-none" />
              戻る
            </a>
          </div>
        </Col>
        {jsxElementResendMail()}
        {jsxElementChangeDetails()}
      </Row>
      <Popup
        title="相談内容の変更"
        text="相談内容を変更できる状態に戻します。よろしいですか？"
        first_button={{
          label: '相談内容を変更する',
          variant: 'success',
          handleClick: () => {
            handleClickChangeDetails();
            setModalChangeApplicationOpen(false);
          },
        }}
        second_button={{
          label: '戻る',
          variant: 'outline-success',
          handleClick: () => {
            setModalChangeApplicationOpen(false);
          },
        }}
        toggleClose={() => setModalChangeApplicationOpen(false)}
        toggleShow={modal_change_application_open}
      />
    </>
  );
};

export default memo(FooterBorrowingConsultationPreview);
